import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { LocalLink as Link } from '@/lib/locale';

// Policy-style text page: title, intro, then headed sections of paragraphs.
// Copy lives in locales/info/<lang>.js under info.<pageKey>.
export const InfoPage = ({ pageKey }) => {
  const { t } = useTranslation();
  const page = t(`info.${pageKey}`, { returnObjects: true });

  useEffect(() => {
    document.title = t('meta.infoTitle', { name: page.title });
  }, [t, page.title]);

  return (
    <main className="mx-auto max-w-[760px] px-4 pb-16 pt-8 md:px-6 md:pt-14" data-testid={`info-page-${pageKey}`}>
      <h1 className="font-heading text-[40px] font-extrabold leading-none tracking-[-0.035em] md:text-[56px]">{page.title}</h1>
      {page.intro && <p className="mt-5 text-[17px] text-candy-ink-muted">{page.intro}</p>}

      <div className="mt-8 flex flex-col gap-8">
        {page.sections.map((section) => (
          <section key={section.heading}>
            <h2 className="font-heading text-[22px] font-extrabold tracking-[-0.02em] md:text-[26px]">{section.heading}</h2>
            {section.paragraphs.map((text) => (
              <p key={text} className="mt-3 text-candy-ink-muted">
                {text}
              </p>
            ))}
          </section>
        ))}
      </div>

      <p className="mt-12 rounded-block bg-candy-surface p-6 text-candy-ink-muted">
        {t('info.questionsLeft')}{' '}
        <Link to="/contact" className="font-bold text-candy-ink underline underline-offset-2">
          {t('info.contact.link')}
        </Link>
      </p>
    </main>
  );
};
